import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IntegrationService } from '../integration.service';
import { Router } from '@angular/router';
import { NotifierService } from "angular-notifier";
import * as chrono from "chrono-node";
@Component({
  selector: 'app-alter-sub',
  templateUrl: './alter-sub.component.html',
  styleUrls: ['./alter-sub.component.css']
})
export class AlterSubComponent implements OnInit {

  private readonly notifier: NotifierService;
  private subscriberId;
  constructor(private http:HttpClient,private router:Router,private _integrationService:IntegrationService,notifierService: NotifierService) {
    this._integrationService.userId$.subscribe((data)=>{this.subscriberId=data.replace(/"/g,"")});
    this.notifier = notifierService;
  }
  subscriptionName = localStorage.getItem('subName') || '';
  subscriptionUrl = localStorage.getItem('subUrl') || '';
  nextBillingDate = localStorage.getItem('nextBill') || '';
  price = localStorage.getItem('price') || ''
  paymentSched = localStorage.getItem('paySched') || '';

  ngOnInit() {
  }

  updateName(value){
    this.subscriptionName = value;
  }

  updateUrl(value){
    this.subscriptionUrl = value.replace('http://','').replace('https://','').split('/')[0];
  }

  updatePrice(value){
    console.log(this.price)
    this.price = value;
    console.log(this.price)
  }

  updateSched(value){
    this.paymentSched = value;
  }

  updateBillingDate(value){
    this.nextBillingDate = value;
  }

  add(endSub){
    let reqBody = {
      subscriberId:this.subscriberId,
      subscriptionName:this.subscriptionName,
      subscriptionUrl:this.subscriptionUrl,
      nextBillDate:chrono.parseDate(endSub).toISOString().slice(0,10),
      paymentSched:this.paymentSched ? this.paymentSched : 'monthly',
      price:this.price,
      method:'manual'
    }
    console.log(endSub)
    let endpoint = 'https://subscrybe-backend.herokuapp.com/add-subscription'
    this.http.post(endpoint,reqBody).subscribe(
      data=>{
        this.router.navigate(['success'])
      },error=>{
        this.notifier.notify("error","Error adding subscription,try again")
      }
    )
  }


}
